import { render } from "./CatalogMenuFilter.vue?vue&type=template&id=3ffc9e19&scoped=true"
import script from "./CatalogMenuFilter.vue?vue&type=script&lang=js"
export * from "./CatalogMenuFilter.vue?vue&type=script&lang=js"

import "./CatalogMenuFilter.vue?vue&type=style&index=0&id=3ffc9e19&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffc9e19"]])

export default __exports__